import { render, staticRenderFns } from "./InsurerAnnotations.vue?vue&type=template&id=78e12750&scoped=true"
import script from "./InsurerAnnotations.vue?vue&type=script&lang=js"
export * from "./InsurerAnnotations.vue?vue&type=script&lang=js"
import style0 from "./InsurerAnnotations.vue?vue&type=style&index=0&id=78e12750&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e12750",
  null
  
)

export default component.exports